import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FTGroup from './components/FTGroup';
import './styles.scss';

class FTForm extends Component {

    renderGroups() {
        const {
            groups,
            setGlobalModal,
            changeSelectionOrder,
            isMobile,
            currencySign,
            setStake,
            setIsEditingStake,
            setMultiplesError,
            clearMultiplesError,
        } = this.props;

        return Object.entries(groups).map(group => (
            <FTGroup
                key={group[0]}
                group={group[1]}
                setGlobalModal={setGlobalModal}
                changeSelectionOrder={changeSelectionOrder}
                isMobile={isMobile}
                currencySign={currencySign}
                setStake={setStake}
                setIsEditingStake={setIsEditingStake}
                setMultiplesError={setMultiplesError}
                clearMultiplesError={clearMultiplesError}
            />
        ));
    }

    render() {
        const { classBlockName } = this.props;

        return (
            <form className={`${classBlockName}`}>
                {this.renderGroups()}
            </form>
        );
    }
}

FTForm.defaultProps = {
    classBlockName: 'bs-ft-form',
    groups: {},
    isMobile: false,
    currencySign: '£',
    setStake: () => {},
    setIsEditingStake: () => {},
    setGlobalModal: () => {},
    changeSelectionOrder: () => {},
    setMultiplesError: () => {},
    clearMultiplesError: () => {},
};

FTForm.propTypes = {
    classBlockName: PropTypes.string,
    groups: PropTypes.shape({}).isRequired,
    isMobile: PropTypes.bool.isRequired,
    currencySign: PropTypes.string.isRequired,
    setStake: PropTypes.func.isRequired,
    setIsEditingStake: PropTypes.func.isRequired,
    setGlobalModal: PropTypes.func.isRequired,
    changeSelectionOrder: PropTypes.func.isRequired,
    setMultiplesError: PropTypes.func.isRequired,
    clearMultiplesError: PropTypes.func.isRequired,
};

export default FTForm;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/FTForm/FTForm.jsx